import { useState, useEffect } from 'react';
var Type = Function;

function isType(v) {
  return typeof v === 'function';
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
/**
 * The 1st injector instance is considered the 'root' injector
 * The root injector my be auto-added as a parent to all subsequent injector instances
 */


var rootInjector;
/**
 * Utility function used to easily create 1..n injectors; each with thier
 * own singletons and provider registry.
 *
 * NOTE: If only a class is registered (instead of a Provider), convert to it
 * for normalized usages
 */

function makeInjector(registry, parent) {
  var isParentDefined = typeof parent !== 'undefined'; // Always use the Provider long-form to register, e.g
  // { provide: MyClazz, useClass: MyClazz } instead of MyClazz

  var normalized = registry.map(function (it) {
    var isProvider = !!it.provide;
    return isProvider ? it : makeClassProvider(it);
  }); // Auto add root injector as parent unless the parent is already defined...

  var instance = new Injector(normalized, isParentDefined ? parent : rootInjector);
  !rootInjector && (rootInjector = instance);
  return instance;
}
/**
 * Injector class that manages a registry of Providers and a registry
 * of singleton instances [singletons for the instance of the injector]
 */


var Injector = /*#__PURE__*/function () {
  function Injector() {
    var providers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var parent = arguments.length > 1 ? arguments[1] : undefined;

    _classCallCheck(this, Injector);

    this.providers = providers;
    this.parent = parent;
    this.singletons = new WeakMap();
    this.addProviders(providers);
  }
  /**
   * Lookup singleton instance using token
   * Optionally create instance and save as singleton if needed
   * If not found, this will search a parent injector (if provided)
   */


  _createClass(Injector, [{
    key: "get",
    value: function get(token) {
      var inst = this.findAndMakeInstance(token);
      return inst || (this.parent ? this.parent.get(token) : null);
    }
    /**
     * Force-clear internally singleton cache.
     * If parents are specified, this enforces correct parent lookups
     * for future instantiations.
     */

  }, {
    key: "reset",
    value: function reset() {
      if (this.parent) {
        this.singletons = new WeakMap();
      }
    }
    /**
     * Create an unshared, non-cached instance of the token;
     * based on the Provider configuration
     * If not found, then consider asking parent injector for the
     * instance
     */

  }, {
    key: "instanceOf",
    value: function instanceOf(token) {
      var inst = this.instanceFromRegistry(token) || this.instanceFromParents(token);

      if (!inst) {
        throw new Error("Unable make instance of ".concat(String(token)));
      }

      return inst;
    }
    /**
     * Dynamically allow Provider registrations and singleton overwrites
     * Provide an 'restore' function to optionally restore original providers (if replaced),
     *
     * @param registry Configuration set of Provider(s)
     * @param replace Replace existing provider
     */

  }, {
    key: "addProviders",
    value: function addProviders(registry) {
      var _this = this;

      var origProviders = _toConsumableArray(this.providers);

      this.providers = mergeProviders(this.providers, registry);
      registry.map(function (it) {
        return _this.singletons["delete"](it.provide);
      });
      return function () {
        return _this.addProviders(origProviders);
      };
    }
    /**
     * Get all Token providers from parent(s), updated with current overwrites (if any).
     *
     * This allows the full parent registry tree to be flattened
     * with current level acting as overwrites
     */

  }, {
    key: "getFlatProviderTree",
    value: function getFlatProviderTree() {
      return !this.parent ? _toConsumableArray(this.providers) : _toConsumableArray(mergeProviders(this.parent.getFlatProviderTree(), this.providers));
    } // *************************************************
    // Private  Methods
    // *************************************************

    /**
     * Ask parent injectors (if any) for a flattened Provider registry,
     * then try to build the instance. When done, restore the original
     * Provider registry for this injector
     */

  }, {
    key: "instanceFromParents",
    value: function instanceFromParents(token) {
      if (!this.parent) return undefined;

      var original = _toConsumableArray(this.providers);

      try {
        this.providers = mergeProviders(this.getFlatProviderTree(), this.providers);
        return this.instanceFromRegistry(token);
      } finally {
        this.providers = original;
      }
    }
    /**
     * Find last Provider registration (last one wins)
     */

  }, {
    key: "findLastRegistration",
    value: function findLastRegistration(token, list) {
      var registry = this.providers.filter(function (it) {
        return it.provide === token;
      });
      return registry.length ? registry[registry.length - 1] : null;
    }
    /**
     * Based on provider registration, create instance of token and save
     * as singleton value.
     * NOTE: do not scan parent since we are caching singletons at this level only.
     *
     * @param token Class, value, or factory
     */

  }, {
    key: "findAndMakeInstance",
    value: function findAndMakeInstance(token) {
      var result = this.singletons.get(token) || this.instanceOf(token);
      result && this.singletons.set(token, result);
      return result;
    }
  }, {
    key: "instanceFromRegistry",
    value: function instanceFromRegistry(token) {
      var makeAndCache = this.findAndMakeInstance.bind(this);
      var provider = this.findLastRegistration(token, this.providers);
      var deps = provider && provider.deps ? provider.deps.map(makeAndCache) : [];

      var makeWithClazz = function makeWithClazz(clazz) {
        return clazz ? _construct(clazz, _toConsumableArray(deps)) : null;
      };

      var makeWithFactory = function makeWithFactory(fn) {
        return fn ? fn.call(null, deps) : null;
      };

      return provider && (provider.useValue || makeWithClazz(provider.useClass) || makeWithFactory(provider.useFactory) || makeWithClazz(provider.provide)) // fallback uses the token as a `class`
      ;
    }
  }]);

  return Injector;
}();
/**
 * Internal utility used to normalized Provider entries
 * during a `makeInjector()` call
 *
 * @param token
 */


function makeClassProvider(token) {
  return {
    provide: token,
    useClass: token,
    deps: _toConsumableArray(token['deps'] || [])
  };
}
/**
 * Merge current provider registry with 1..n updated Provider settings;
 * where the `updated` set may contain either modified and/or new configurations
 */


function mergeProviders(current, updated) {
  var extractToken = function extractToken(it) {
    return it.provide;
  };

  var findByToken = function findByToken(token) {
    return allEntries.find(function (it) {
      return it.provide === token;
    });
  };

  var allEntries = [].concat(_toConsumableArray(updated), _toConsumableArray(current));
  var allTokens = new Set(allEntries.map(extractToken)); // Reduce combined set to entries unique by Token, prioritize updated entries first.

  return Array.from(allTokens).map(findByToken);
}
/**
 * @description
 *
 * Creates a token that can be used in a DI Provider.
 *
 * Use an `InjectionToken` whenever the type you are injecting is not reified (does not have a
 * runtime representation) such as when injecting an interface, callable type, array or
 * parameterized type.
 *
 * `InjectionToken` is parameterized on `T` which is the type of object which will be returned by
 * the `Injector`. This provides additional level of type safety.
 *
 * ```
 * interface MyInterface {...}
 * var myInterface = injector.get(new InjectionToken<MyInterface>('SomeToken'));
 * // myInterface is inferred to be MyInterface.
 * ```
 *
 * When creating an `InjectionToken`, you can optionally specify a factory function which returns
 * (possibly by creating) a default value of the parameterized type `T`. This sets up the
 * `InjectionToken` using this factory as a provider as if it was defined explicitly in the
 * application's root injector. If the factory function, which takes zero arguments, needs to inject
 * dependencies, it can do so using the `inject` function. See below for an example.
 *
 * Additionally, if a `factory` is specified you can also specify the `providedIn` option, which
 * overrides the above behavior and marks the token as belonging to a particular `@NgModule`. As
 * mentioned above, `'root'` is the default value for `providedIn`.
 *
 * @publicApi
 */


var InjectionToken = /*#__PURE__*/function () {
  function InjectionToken(_desc) {
    _classCallCheck(this, InjectionToken);

    this._desc = _desc;
  }

  _createClass(InjectionToken, [{
    key: "toString",
    value: function toString() {
      return "InjectionToken ".concat(this._desc);
    }
  }]);

  return InjectionToken;
}();

function useInjectorHook(token, injector) {
  return [injector.get(token), injector];
}
/**
 * Manage Observable subscription and report value emission.
 * - support dynamic reset of stream source
 * - support auto-unsubscribe when view component unmounts
 * @param observable$ Stream source
 * @param initialValue initial value; to simulate 1st stream emission
 */


function useObservable(observable$, initialValue) {
  var _useState = useState(observable$),
      _useState2 = _slicedToArray(_useState, 2),
      source$ = _useState2[0],
      setObservable = _useState2[1];

  var _useState3 = useState(initialValue),
      _useState4 = _slicedToArray(_useState3, 2),
      value = _useState4[0],
      setValue = _useState4[1];

  var reportError = function reportError(err) {
    return console.error("useObservable() error: ".concat(JSON.stringify(err)));
  };

  useEffect(function () {
    if (source$) {
      var s = source$.subscribe(setValue, reportError);
      return function () {
        s.unsubscribe();
      };
    }
  }, [source$]);
  return [value, setObservable];
}
/**
 *  Utility `switchCase` to functionaly make case statements easy to process by
 *  using a case hashmap:
 *
 *  @Code
 *    (1) Used to perform quick lookups with fallbacks
 *
 *        const dayofWeek: SwitchCase<number, string> = switchCase({
 *          0: 'Sunday',
 *          1: 'Monday',
 *          2: 'Tuesday',
 *          3: 'Wednesday',
 *          4: 'Thursday',
 *          5: 'Friday',
 *          6: 'Saturday'
 *        },'Unknown'));
 *
 *        const currentDay = dayofWeek(new Date().getDay())
 *
 *
 *     (2)  Used to simply Redux state reducers:
 *
 *         export const counterReducer = <T extends ActionNames<typeof handleAction>>(
 *           state: number, action: { type: T }
 *         ) => {
 *           const handleAction = switchCase({
 *              'INCREMENT': () => state + 1,
 *              'DECREMENT': () => state - 1,
 *              'RESET': 0,
 *           }, state);
 *           return handleAction(action.type);
 *         };
 *
 *         console.log(counterReducer(0, { type: 'INCREMENT' }));      // perfect
 *         console.log(counterReducer("wrong", { type: 'FOO' }));      // intellisense shows errors
 *         console.log(counterReducer(0, { type: 'FOO' }));            // intellisense shows errors
 */


var findCaseValue = function findCaseValue(cases, defaultCase) {
  return function (key) {
    return cases[key] || defaultCase;
  };
};

var switchCase = function switchCase(cases, defaultCase) {
  return function (key) {
    var f = findCaseValue(cases, defaultCase)(key);
    return f instanceof Function ? f() : f;
  };
};

export { InjectionToken, Type, isType, makeInjector, rootInjector, switchCase, useInjectorHook, useObservable };